import type { UseFormReturn } from "react-hook-form";
import type { ThemeClasses, PointOfInterestFormValues, MapPoint } from "../types";
import Modal from "../../../../../../components/base/Modal";
import { APIProvider } from "@vis.gl/react-google-maps";
import { PointOfInterestForm } from "./PointOfInterestForm";
import { PointOfInterestMapPreview } from "./PointOfInterestMapPreview";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";
import { useTranslation } from "react-i18next";

interface PointOfInterestModalProps {
  isOpen: boolean;
  isEdit: boolean;
  loadingSubmit: boolean;
  form: UseFormReturn<PointOfInterestFormValues>;
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  mapCenter: MapPoint;
  markerPosition: MapPoint | null;
  hasRealChanges: () => boolean;
  onMarkerPositionChange: (position: MapPoint) => void;
  onCoordinateChange: (lat: number, lng: number) => void;
  onSubmit: (data: PointOfInterestFormValues) => void;
  onClose: () => void;
}

export function PointOfInterestModal({
  isOpen,
  isEdit,
  loadingSubmit,
  form,
  themeClasses,
  isDarkMode,
  mapCenter,
  markerPosition,
  hasRealChanges,
  onMarkerPositionChange,
  onCoordinateChange,
  onSubmit,
  onClose,
}: PointOfInterestModalProps) {
  const { t } = useTranslation("adminSections");
  const disableCRUD = useDisableCRUD();

  if (!isOpen) return null;

  return (
    <Modal
      title={isEdit ? t("pointsOfInterest.modal.editTitle") : t("pointsOfInterest.modal.addTitle")}
      onClose={onClose}
      themeClasses={themeClasses}
      width="w-[90vw] max-w-4xl"
      disableCRUD={disableCRUD}
      content={
        <APIProvider
          apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
          libraries={["places"]}
        >
          {/* Formulario con mapa integrado entre Dirección y Visibilidad */}
          <PointOfInterestForm
            form={form}
            isEdit={isEdit}
            loadingSubmit={loadingSubmit}
            hasRealChanges={hasRealChanges}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            onCoordinateChange={onCoordinateChange}
            onSubmit={onSubmit}
            onCancel={onClose}
            mapComponent={
              <PointOfInterestMapPreview
                themeClasses={themeClasses}
                isDarkMode={isDarkMode}
                mapCenter={mapCenter}
                markerPosition={markerPosition}
                onMarkerPositionChange={onMarkerPositionChange}
                readOnly={false}
              />
            }
          />
        </APIProvider>
      }
    />
  );
}
